.box > *:not(:only-child) {
    margin: 0.5rem;
}
